import { render, staticRenderFns } from "./BoxGroup.vue?vue&type=template&id=7b107c92&scoped=true"
import script from "./BoxGroup.vue?vue&type=script&lang=js"
export * from "./BoxGroup.vue?vue&type=script&lang=js"
import style0 from "./BoxGroup.vue?vue&type=style&index=0&id=7b107c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b107c92",
  null
  
)

export default component.exports